import {getCountdownMarginBottom, isCountdownVisible} from '../../../selectors/single-settings'
import {AppProps} from '../../app/interfaces'
import {renderIfVisible} from '../../hoc/render-if-visible'
import {withMargin} from '../../hoc/with-margin'
import {Countdown as CountdownPresentation} from './countdown'

const getMargin = ({state}: AppProps) => getCountdownMarginBottom(state)

export const Countdown = renderIfVisible(withMargin(CountdownPresentation, getMargin), isCountdownVisible)
